import React, { useRef } from 'react';

import { IEmployee } from '@entities/employee/model/types';
import { useIsOverflowing } from '@shared/hooks';
import { UiText } from '@shared/ui';

import cls from './EmployeeEmail.module.css';

interface IEmployeeEmailProps {
    name: IEmployee['name'];
    email: IEmployee['email'];
}

export const EmployeeEmail = ({ name, email }: IEmployeeEmailProps) => {
    const emailRef = useRef<HTMLSpanElement>(null);
    const { isOverflowing } = useIsOverflowing({ elRef: emailRef });

    return (
        <span className={cls.ellipsisOneLine} title={isOverflowing ? email : null} ref={emailRef}>
            <UiText tag="span" classes={name && cls.colorTertiary} variant="caption" align="center">
                {email}
            </UiText>
        </span>
    );
};
